import { createRouter, createWebHistory } from 'vue-router'
import { createRouterGuards } from './router-guards'

const Home = () => import('@/pages/index')
const Template = () => import('@/pages/template')
const Preview = () => import('@/pages/preview')
const Editor = () => import('@/pages/editor')
const User = () => import('@/pages/user')
const Login = () => import('@/pages/user/login')
const Register = () => import('@/pages/user/register')

const routes = [
  { path: '/', component: Home },
  { name: 'PageTemplate', path: '/template', component: Template },
  { name: 'PagePreview', path: '/preview/:id', component: Preview },
  { name: 'PageEditor', path: '/editor/:id', component: Editor },
  {
    path: '/user',
    component: User,
    children: [
      {
        path: 'login',
        component: Login
      },
      {
        path: 'register',
        component: Register
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  strict: true
})

export function setupRouter(app) {
  app.use(router)
  // 创建路由守卫
  createRouterGuards(router)
}

export default router
